// Generated by scripts/generate_roles.py from hub flowpad/enums/auth_enums.py.
export const ROLE_ORDER = ["owner", "owner_by_api", "admin", "editor", "reader", "runner"] as const;
export const Role = {"OWNER": "owner", "OWNER_BY_API": "owner_by_api", "ADMIN": "admin", "EDITOR": "editor", "READER": "reader", "RUNNER": "runner"} as const;
export const ROLE_PEER_INVITE_TYPES: readonly string[] = ["conversation"];
export type Role = (typeof ROLE_ORDER)[number];
export const MEMBERSHIP_ROLES: readonly Role[] = ["owner", "admin", "editor", "reader", "runner"];
export const ROLE_INCLUDES: Record<Role, readonly Role[]> = {
  "owner": [
    "owner",
    "admin",
    "editor",
    "reader",
    "runner"
  ],
  "owner_by_api": [
    "owner_by_api"
  ],
  "admin": [
    "admin",
    "editor",
    "reader",
    "runner"
  ],
  "editor": [
    "editor",
    "reader",
    "runner"
  ],
  "reader": [
    "reader"
  ],
  "runner": [
    "runner"
  ]
};
export const ROLE_GRANTS: Record<Role, readonly Role[]> = {
  "owner": [
    "admin",
    "editor",
    "reader",
    "runner"
  ],
  "owner_by_api": [],
  "admin": [
    "editor",
    "reader",
    "runner"
  ],
  "editor": [],
  "reader": [],
  "runner": []
};

export function normalizeRoles(value: readonly string[] | string | null | undefined): Role[] {
  const roles = (typeof value === 'string' ? [value] : value ?? []).map(role => {
    if (typeof role !== 'string') throw new Error('Roles must contain strings');
    return role.trim().toLowerCase();
  });
  for (const role of roles) {
    if (!(ROLE_ORDER as readonly string[]).includes(role)) throw new Error(`Unknown role: ${role}`);
  }
  return ROLE_ORDER.filter(role => roles.includes(role));
}
export function normalizeMembershipRoles(value: readonly string[] | string | null | undefined): Role[] {
  const roles = normalizeRoles(value);
  if (roles.some(role => !MEMBERSHIP_ROLES.includes(role))) throw new Error('Unassignable membership role');
  return roles;
}
export function normalizeRetainedRoles(value: readonly string[] | null | undefined): Role[] {
  const roles = normalizeMembershipRoles(value);
  if (roles.some(role => !ROLE_GRANTS.owner.includes(role))) throw new Error('Unassignable retained role');
  return roles;
}
export function roleCapabilities(value: readonly string[]): Set<Role> {
  return new Set(normalizeRoles(value).flatMap(role => ROLE_INCLUDES[role]));
}
export function grantableRoleSet(value: readonly string[]): Role[] {
  const granted = new Set(normalizeRoles(value).flatMap(role => ROLE_GRANTS[role]));
  return ROLE_ORDER.filter(role => granted.has(role));
}
export function newInviteRoles(held: readonly string[], entityType: string): Role[] {
  const grants = grantableRoleSet(held);
  if (grants.length || !ROLE_PEER_INVITE_TYPES.includes(entityType)) return grants;
  const capabilities = roleCapabilities(held);
  return ROLE_ORDER.filter(role => (role === 'reader' || role === 'runner') && capabilities.has(role));
}
export function canManageRoles(held: readonly string[], target: readonly string[]): boolean {
  const grants = grantableRoleSet(held);
  return target.length > 0 && normalizeRoles(target).every(role => grants.includes(role));
}
